import { render, staticRenderFns } from "./filled-star.vue?vue&type=template&id=1323b5f0&functional=true"
import script from "./filled-star.vue?vue&type=script&lang=js"
export * from "./filled-star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports